<template>
  <v-container class="pa-0 ma-0 w-100" v-if="employEmails.length > 0">
    <v-list-item
        v-for="email in employEmails"
        :key="email">
      <EmailListItem :email="email" />
    </v-list-item>
  </v-container>
  
  <div class="d-flex justify-center" v-else>
    <small>Keine Emails gefunden</small>
  </div>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {useStore} from "@/store";
import {useCollection} from "vuefire";
import {collection, query, where} from "firebase/firestore";
import {db} from "@/main";
import EmailListItem from "@/components/EmailListItem.vue";

const props = defineProps({
  emailAdress: { type:String, required: true }
});

const store = useStore();
const emailAdress = props.emailAdress;
const emails = useCollection(collection(db, 'mail'));

const employEmails = computed(() => {
  return emails.value
    .filter(email => email.to === emailAdress)
    .sort((a, b) => b.delivery.startTime - a.delivery.startTime)
});

</script>